module.exports = __webpack_public_path__ + "img/content-save.5f3f3423.svg";